import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private _scroll: Subject<Event> = new BehaviorSubject<Event>(undefined);
  public readonly onScroll: Observable<Event> = this._scroll.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: string) {
    if (isPlatformServer(this.platformId)) return;
    window.addEventListener('scroll', e => this._scroll.next(e), true);
  }

  public registerScroll() {
    this._scroll.next(undefined);
  }
}
